var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('invoices-table',{attrs:{"api":_vm.invoicesApi,"moreParams":_vm.moreParams},on:{"setInvoiceTotal":_vm.getInvoiceTotal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }